import React, { useEffect, useState } from 'react';
import { CustomModal, Loader } from '@nile/components';
import CustomFieldSheet from '@nile/banyan/src/Components/Sheets/CustomFieldSheet';
import styled from 'styled-components';
import { useQuery } from '@apollo/client';
import { MockTicketClient } from '@nile/graphql/src';
import { SVGIcon } from '@superops/super-icons';
import { Button } from '@superops/ui-design-system';
import { FormattedMessage } from 'react-intl';

const ModalWrapper = styled.div`
  width: 600px;
  height: 220px;
  background: #fff;
  border-radius: 10px;
  padding: 40px 40px 20px 20px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  .modal-content {
    display: flex;
    gap: 20px;
  }

  .alert-text {
    font-weight: 600;
    font-size: 24px;
    line-height: 24px;
    margin-bottom: 10px;
  }

  .description {
    font-weight: 500;
    font-size: 14px;
    line-height: 24px;
  }

  .action-buttons {
    display: flex;
    margin-top: 20px;
    justify-content: flex-end;
    gap: 10px;
  }
`;

const WarningModal = (props) => {
  const {
    modalActive,
    setModalActive,
    // data,
    value,
    setValue
    // updateField
  } = props;

  // const {
  //   id,
  //   label,
  //   fieldType,
  //   options,
  //   showToClient,
  //   description,
  //   columnName,
  //   module,
  //   mandatoryOnCreation,
  //   mandatoryOnClosure
  // } = data;

  const closeModal = () => {
    setModalActive(!modalActive);
    setValue(value);
  };

  const toggleModal = () => {
    setModalActive(!modalActive);
    setValue(!value);
  };

  // const primaryAction = () => {
  //   setModalActive(!modalActive);
  //   updateField({
  //     variables: {
  //       id,
  //       label,
  //       fieldType,
  //       options,
  //       showToClient,
  //       description,
  //       columnName,
  //       module,
  //       mandatoryOnCreation,
  //       mandatoryOnClosure
  //     }
  //   });
  // };

  return (
    <>
      <CustomModal
        open={modalActive}
        onClose={() => setModalActive(!modalActive)}
      >
        <ModalWrapper className="modal-wrapper">
          <div className="modal-content">
            <div>
              <SVGIcon name="WarningIcon" color="#F07602" size="xxl" />
            </div>
            <div className="content-wrapper">
              <div className="text">
                <p className="alert-text">
                  <FormattedMessage id="app.general.toast.warning" />
                </p>
                <p className="description">
                  <FormattedMessage id="admin.formbuilder.mandatoryFieldChange.warning.message" />
                </p>
              </div>
            </div>
          </div>

          <div className="action-buttons">
            <Button onClick={closeModal} plainSecondary>
              <FormattedMessage id="common.no" />
            </Button>

            <Button onClick={toggleModal} primary>
              <FormattedMessage id="common.yes" />
            </Button>
          </div>
        </ModalWrapper>
      </CustomModal>
    </>
  );
};

export default WarningModal;
